<template>
  <b-form-group :label-sr-only="noLabel">
    <template #label>
      <span>{{ $t(label) }}</span>
      <span v-if="required && label" class="text-danger">*</span>
    </template>
    <b-input-group :prepend-html="$t(prepend)">
      <b-form-input
        v-model="content"
        :state="state"
        @input="handleInput"
        :type="type"
        :readonly="readonly"
        :formatter="formatter"
        :placeholder="$t(placeholder)"
        :lazy="lazy"
        @wheel="$event.target.blur()"
        :min="min"
        :max="max"
        :size="size"
        @keyup.enter="sendEnterEvent"
        @change="setChanged"
        :disabled="disabled"
      />
      <b-input-group-append>
        <b-button variant="primary" @click="btnEmit">
          {{ $t(btnAppend) }}
        </b-button>
      </b-input-group-append>

      <slot name="append"></slot>
      <b-form-invalid-feedback>
        {{ feedback }}
      </b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: 'InputBtn',
  props: {
    stateCustom: { type: Boolean, default: true },
    value: { type: [String, Number], default: '' },
    type: { type: String, default: 'text' },
    label: { type: String },
    size: { type: String },
    upper: { type: Boolean },
    noLabel: { type: Boolean, default: false },
    removeSpecialChars: { type: Boolean },
    removeWhiteSpaces: { type: Boolean },
    required: { type: Boolean },
    requiredMessage: { type: String },
    readonly: { type: Boolean, default: false },
    length: { type: Number, default: 0 },
    lengthMessage: { type: String },
    minLength: { type: Number, default: null },
    minLengthMessage: { type: String },
    maxLength: { type: Number, default: null },
    maxLengthMessage: { type: String },
    placeholder: { type: String },
    validate: { type: Boolean, default: null },
    lazy: { type: Boolean, default: false },
    min: { type: [Number, String], required: false },
    max: { type: [Number, String], required: false },
    disabled: { type: Boolean, default: false },
    prepend: { type: String, default: String },
    btnAppend: { type: String, default: String },
  },
  data() {
    return {
      content: this.value,
      validForm: false,
      hasError: false,
      errorMessage: '',
      changed: false,
      isField: true,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      deep: true,
      immediate: true,
    },
    content(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
  computed: {
    wasChanged() {
      return this.changed;
    },
    requiredValid() {
      return !(this.required && (this.content == '' || this.content == null));
    },
    minValid() {
      return !(this.min && parseInt(this.content) < parseInt(this.min));
    },
    maxValid() {
      return !(this.max && parseInt(this.content) > parseInt(this.max));
    },
    lengthValid() {
      return !(this.length > 0 && String(this.content)?.length != this.length);
    },
    minLengthValid() {
      return !(this.minLength > 0 && this.content?.length < this.minLength);
    },
    maxLengthValid() {
      return !(this.maxLength > 0 && this.content?.length > this.maxLength);
    },
    state() {
      if (!this.stateCustom) return false;

      if (!this.validForm) return null;

      if (!this.requiredValid) return false;
      if (!this.minValid) return false;
      if (!this.maxValid) return false;
      if (!this.lengthValid) return false;
      if (!this.minLengthValid) return false;
      if (!this.maxLengthValid) return false;
      if (this.hasError) return false;
      if (this.validate != null) return this.validate;

      return true;
    },
    feedback() {
      if (!this.validarFormulario) return '';
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.REQUERIDO').formatUnicorn({
            name: this.label,
          })
        );
      if (!this.minValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.VALOR_MINIMO').formatUnicorn({
            min: this.min,
          })
        );
      if (!this.maxValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.VALOR_MAXIMO').formatUnicorn({
            max: this.max,
          })
        );
      if (!this.lengthValid)
        return (
          this.lengthMessage ||
          this.$t('CAMPOS_VALIDACAO.TAMANHO').formatUnicorn({
            name: this.label,
            length: this.length,
          })
        );
      if (!this.minLengthValid)
        return (
          this.minLengthMessage ||
          this.$t('CAMPOS_VALIDACAO.COMPRIMENTO_MINIMO').formatUnicorn({
            name: this.label,
            length: this.minLength,
          })
        );
      if (!this.maxLengthValid)
        return (
          this.maxLengthMessage ||
          this.$t('CAMPOS_VALIDACAO.COMPRIMENTO_MAXIMO').formatUnicorn({
            name: this.label,
            length: this.maxLength,
          })
        );

      if (this.hasError) return this.errorMessage;
      return '';
    },
  },
  methods: {
    showError(message) {
      this.validForm = true;
      this.hasError = true;
      this.errorMessage = message;
    },
    formatter(e) {
      if (e) {
        if (this.upper) e = e.toUpperCase();

        if (this.maxLength > 0 && e.length > this.maxLength) {
          e = e.substring(0, this.maxLength);
        }

        if (this.removeSpecialChars)
          e = e.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');

        if (this.removeWhiteSpaces) e = e.replace(/\s/g, '');
      }

      return e;
    },
    handleInput() {
      this.$emit('input', this.content);
      this.hasError = false;
    },
    valid() {
      this.validForm = true;
      return this.state;
    },
    clear() {
      this.content = '';
      this.validForm = false;
      this.$emit('input', this.content);
    },
    sendEnterEvent() {
      this.$emit('enter');
    },
    setChanged() {
      this.changed = true;
    },
    btnEmit() {
      this.$emit('btn-emit');
    },
  },
};
</script>
